import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class AffiliateTypes {
  static listAffiliates: IActionType = new ActionType('AFFILIATE/LIST_AFFILIATE');
  static configCustomCommission: IActionType = new ActionType('AFFILIATE/CONFIG_CUSTOM_COMMISSION');
  static moderateAffiliate: IActionType = new ActionType('AFFILIATE/MODERATE_AFFILIATE');
  static moderateMultipleAffiliates: IActionType = new ActionType('AFFILIATE/MODERATE_MULTIPLE_AFFILIATES');
  static exportAffiliates: IActionType = new ActionType('AFFILIATE/EXPORT_AFFILIATES');
  static getPendingAffiliatesSummaryList: IActionType = new ActionType('AFFILIATE/GET_PENDING_AFFILIATES_SUMMARY_LIST');
  static getPendingAffiliatesSummaryCount: IActionType = new ActionType('AFFILIATE/GET_PENDING_AFFILIATES_SUMMARY_COUNT');
}

export default AffiliateTypes;
